module.exports = __webpack_public_path__ + "img/mobile.a53db6de.jpg";